module.exports = __webpack_public_path__ + "img/product-fengkong2.a37b04d9.svg";